/* Copie klikcamera.com : comportements des pages (FAQ, suivi de commande, formulaires). */
(function () {
  if (window.KCPages) return;

  /* ---------- Accordéons FAQ (ouverture animée comme Symmetry) ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('.kc-faq-item details:not([data-kc-ready])').forEach(function (details) {
      details.setAttribute('data-kc-ready', '');
      var summary = details.querySelector('summary');
      var panel = details.querySelector('.kc-faq-item__panel');
      if (!summary || !panel) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.hasAttribute('open') && !details.classList.contains('is-closing')) {
          panel.style.height = panel.scrollHeight + 'px';
          details.classList.add('is-closing');
          requestAnimationFrame(function () { panel.style.height = '0px'; });
          setTimeout(function () {
            details.removeAttribute('open');
            details.classList.remove('is-closing');
            panel.style.height = '';
          }, 300);
        } else {
          details.classList.remove('is-closing');
          details.setAttribute('open', '');
          var h = panel.scrollHeight;
          panel.style.height = '0px';
          requestAnimationFrame(function () {
            panel.style.height = h + 'px';
            setTimeout(function () { panel.style.height = ''; }, 300);
          });
        }
      });
    });
  }

  /* ---------- Index et recherche de la FAQ ---------- */
  function initFaq() {
    var head = document.querySelector('[data-kc-faq-head]');
    if (!head) return;
    var headings = Array.prototype.slice.call(document.querySelectorAll('.kc-faq-tabs__heading'));
    var list = head.querySelector('[data-kc-faq-index-list]');
    var tabsSections = document.querySelectorAll('.kc-faq-tabs');
    tabsSections.forEach(function (s, i) { s.classList.add('kc-faq-tabs--indexed'); if (i === 0) s.classList.add('kc-faq-tabs--first'); });
    if (list) {
      list.innerHTML = '';
      headings.forEach(function (h) {
        var div = document.createElement('div');
        div.className = 'kc-faq-index__item';
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        a.addEventListener('click', function (e) {
          e.preventDefault();
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + h.id);
        });
        div.appendChild(a);
        list.appendChild(div);
      });
    }
    // hauteur de l'index collant = hauteur jusqu'à la dernière question
    function sizeIndex() {
      var sticky = head.querySelector('.kc-faq-index__sticky');
      if (!sticky) return;
      var all = document.querySelectorAll('.kc-faq-tabs__inner');
      if (!all.length) return;
      var end = all[all.length - 1].getBoundingClientRect().bottom;
      var start = sticky.getBoundingClientRect().top;
      sticky.style.height = Math.max(0, end - start) + 'px';
      var hh = 0;
      document.querySelectorAll('.shopify-section-group-header-group, sticky-header, header').forEach(function (el) {
        var pos = getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') hh = Math.max(hh, el.getBoundingClientRect().height);
      });
      document.documentElement.style.setProperty('--kc-sticky-header', hh + 'px');
    }
    sizeIndex();
    window.addEventListener('resize', sizeIndex);
    window.addEventListener('load', sizeIndex);
    document.addEventListener('toggle', function () { setTimeout(sizeIndex, 320); }, true);
    document.addEventListener('click', function (e) { if (e.target.closest('.kc-faq-item summary')) setTimeout(sizeIndex, 330); });

    var input = head.querySelector('.kc-faq-search__input');
    var empty = head.querySelector('.kc-faq-search__empty');
    if (!input) return;
    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    input.addEventListener('input', function () {
      var q = norm(input.value.trim());
      var shown = 0;
      document.querySelectorAll('.kc-faq-tabs').forEach(function (sec) {
        var visibleInSec = 0;
        sec.querySelectorAll('.kc-faq-item').forEach(function (item) {
          var ok = !q || norm(item.textContent).indexOf(q) !== -1;
          item.classList.toggle('is-hidden', !ok);
          if (ok) visibleInSec++;
        });
        var h = sec.querySelector('.kc-faq-tabs__heading');
        var intro = sec.querySelector('.kc-faq-tabs__intro');
        if (h) h.classList.toggle('is-hidden', !!q && visibleInSec === 0);
        if (intro) intro.classList.toggle('is-hidden', !!q);
        shown += visibleInSec;
      });
      if (empty) empty.classList.toggle('is-visible', !!q && shown === 0);
      sizeIndex();
    });
  }

  /* ---------- Suivi de commande ---------- */
  function initTracking(root) {
    (root || document).querySelectorAll('[data-kc-track]:not([data-kc-ready])').forEach(function (box) {
      box.setAttribute('data-kc-ready', '');
      box.querySelectorAll('.kc-track__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-target');
          box.querySelectorAll('.kc-track__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
          box.querySelectorAll('.kc-track__col').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-panel') === target); });
        });
      });
      var orderForm = box.querySelector('[data-kc-track-order]');
      if (orderForm) orderForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var num = orderForm.querySelector('[name="order"]');
        var contact = orderForm.querySelector('[name="contact"]');
        var err = orderForm.querySelector('.kc-track__error');
        var msg = '';
        if (!num.value.trim()) msg = orderForm.getAttribute('data-msg-order');
        else if (!contact.value.trim()) msg = orderForm.getAttribute('data-msg-contact');
        if (msg) { err.textContent = msg; err.classList.add('is-visible'); return; }
        err.classList.remove('is-visible');
        window.location.href = orderForm.getAttribute('data-account-url');
      });
      var trackForm = box.querySelector('[data-kc-track-number]');
      if (trackForm) trackForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = trackForm.querySelector('[name="tracking"]');
        var err = trackForm.querySelector('.kc-track__error');
        var v = input.value.trim().replace(/\s+/g, '');
        if (!v) { err.textContent = trackForm.getAttribute('data-msg-tracking'); err.classList.add('is-visible'); return; }
        err.classList.remove('is-visible');
        var tpl = trackForm.getAttribute('data-url') || '';
        if (!tpl) return;
        window.open(tpl.replace('{numero}', encodeURIComponent(v)), '_blank', 'noopener');
      });
    });
  }

  /* ---------- Listes déroulantes des formulaires ---------- */
  function initSelects(root) {
    (root || document).querySelectorAll('.kc-contact select.kc-field-input').forEach(function (sel) {
      var upd = function () { sel.classList.toggle('is-filled', !!sel.value); };
      sel.addEventListener('change', upd); upd();
    });
  }

  function init(root) { initAccordions(root); initFaq(); initTracking(root); initSelects(root); }
  window.KCPages = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
